import React from 'react';

import { URL_IMAGES_PAYSYSTEMS } from 'constants/UrlConstants';

import clsx from 'clsx';

import styles from './Footer.module.css';

export default function Partners(props) {
    const linkClass = clsx(styles.partnersSpan, styles.partnersLink);

    const getImage = (imageName, imgAlt) => {
        return (
            <img
                src={`${URL_IMAGES_PAYSYSTEMS}/${imageName}${props.promoDarkPage ? '-dark' : ''}.svg`}
                loading="lazy"
                decoding="async"
                alt={imgAlt}
                width="64"
                height="64"
            />
        );
    };

    return (
        <div className={styles.partnersList}>
            <span className={styles.partnersSpan}>{getImage('mastercard-squared', 'Mastercard')}</span>
            <span className={styles.partnersSpan}>{getImage('visa-squared', 'Visa')}</span>
            <span className={styles.partnersSpan}>{getImage('unionpay-squared', 'Unionpay')}</span>
            <span className={styles.partnersSpan}>{getImage('visa-verified-squared', 'Verified by Visa')}</span>
            <span className={styles.partnersSpan}>{getImage('mastercard-secure-squared', 'Mastercard secure code')}</span>
            <span className={styles.partnersSpan}>{getImage('napas-squared', 'Napas')}</span>
            <span className={styles.partnersSpan}>{getImage('humo-squared', 'Humo')}</span>
            <span className={styles.partnersSpan}>{getImage('troy-squared', 'Troy')}</span>
            <span className={styles.partnersSpan}>{getImage('uzcard-squared', 'Uzcard')}</span>
            <span className={styles.partnersSpan}>{getImage('verve-squared', 'Verve')}</span>
            <span className={styles.partnersSpan}>{getImage('elcard-squared', 'Elcard')}</span>
            <span className={styles.partnersSpan}>{getImage('kortimilli-squared', 'Kortimilli')}</span>
            <span className={styles.partnersSpan}>{getImage('sepa-squared', 'Sepa')}</span>
            <a className={linkClass} href="https://cloud.paysend.com/web/docs/certificate_pci_dss_en.pdf" target="_blank">
                {getImage('pci-dss-squared', 'PCI')}
            </a>
        </div>
    );
}
